import { globalObject } from '../../tools/globalObject';
export function getConnectivity() {
    const navigator = globalObject.navigator;
    return {
        status: navigator.onLine ? 'connected' : 'not_connected',
        interfaces: navigator.connection && navigator.connection.type ? [navigator.connection.type] : undefined,
        effective_type: navigator.connection?.effectiveType,
    };
}
//# sourceMappingURL=connectivity.js.map